/** Compact field styling shared by the practitioner onboarding and edit forms. */
export const INPUT_CLASS =
  'flex h-9 w-full items-center rounded-md border-0 bg-[#fbfafd] px-3 text-sm text-gray-900 outline-none ring-1 ring-inset ring-gray-200 focus:ring-2 focus:ring-[#061a61] disabled:cursor-not-allowed disabled:bg-gray-100 disabled:text-gray-600';

export const LABEL_CLASS = 'mb-1 block font-hanken text-xs font-medium text-gray-700';

export const ERROR_CLASS = 'mt-1 text-xs text-destructive';
